import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ThreadFilterType } from '../../core/enums/thread-filter-type.enum';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'threadFilterName' })
export class ThreadFilterNamePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(threadFilter: ThreadFilterType): string {
        switch (threadFilter) {
            case ThreadFilterType.unansweredThreads:
                return this.translateService.instant('Unanswered threads');
            case ThreadFilterType.badWords:
                return this.translateService.instant('Bad words');
            case ThreadFilterType.questions:
                return this.translateService.instant('Questions');
            case ThreadFilterType.essence:
                return this.translateService.instant('Essence');
            case ThreadFilterType.handledByMe:
                return this.translateService.instant('Handled by me');
            case ThreadFilterType.handled:
                return this.translateService.instant('Handled');
            case ThreadFilterType.unhandled:
                return this.translateService.instant('Unhandled');
            default:
                return this.translateService.instant('Unknown filter');
        }
    }
}
